// use selected attributes to retrive only needed data from backend
const requiredAtteributes = [
  "sku",
  "ean",
  "name",
  "option_text_brand",
  "prices_with_tax",
  "image",
  "_media_",
  "stock",
  "label",
  "product_fees",
  "rewrite_url",
  "attributes",
  "eligible_for_tabby",
  "eligible_for_tamara",
  "product_fees",
  "back_orders",
  "custom_related_products",
  "option_text_brand",
  "_category_",
  "additional_html",
  "bundle_product_options"
];

const selectedAtteributes = requiredAtteributes
  ?.map((attr) => `select=${attr}`)
  ?.join("&");
export default selectedAtteributes;
